import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Step extends Component {
    renderHorzLine = (len, color) => (
        <div style={{
            border: `1px solid ${color}`,
            height: '0px',
            width: len + 'px'
        }}>
        </div>
    );

    render() {
        let counterSize = this.props.counterSize ?? 30;
        let len = ((this.props.width ?? 150) - counterSize) / 2;
        let fillColor = this.props.counterBackground ?? 'gray';

        return (
            <div style={{
                direction: this.props.ltr ? 'ltr' : 'rtl',
                display: 'inline-flex',
                alignItems: 'center',
                ...this.props.style,
            }}>
                <div>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                    }}>
                        {this.renderHorzLine(len, fillColor)}

                        <div style={{
                            border: `1px solid ${fillColor}`,
                            height: counterSize + 'px',
                            width: counterSize + 'px',
                            borderRadius: (counterSize / 2) + 'px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: (counterSize / 2) + 'px',
                            background: fillColor,
                            color: this.props.counterColor ?? 'white',
                            cursor: 'pointer',

                        }}
                            onClick={this.props.onClick}
                        >
                            {this.props.counter}
                        </div>

                        {this.renderHorzLine(len, fillColor)}
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '10px',
                        color: this.props.textColor ?? this.props.counterBackground ?? 'gray',
                        fontSize: (counterSize * 0.45) + 'px',
                    }}
                        onClick={this.props.onClick}
                    >
                        {this.props.text}
                    </div>
                </div>
            </div>
        );
    }
}

Step.propTypes = {
    ltr: PropTypes.bool,
    counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    text: PropTypes.string,
    counterSize: PropTypes.number,
    width: PropTypes.number,
    counterBackground: PropTypes.string,
    counterColor: PropTypes.string,
    onClick: PropTypes.func,
    textColor: PropTypes.string,
    style: PropTypes.object,
};


class StepCounter extends Component {
    // static defaultProp = {
    //     primaryColor: 'steelblue',
    //     secondaryColor: 'darkred',
    // };

    render() {
        let steps = this.props.texts?.length > 0 ?
            this.props.texts.map(text => ({ text }))
            : this.props.steps > 0 ? Array.from({ length: this.props.steps }, (_, i) => i + 1)
                : this.props.steps;

        let secondaryColorIf = this.props.secondaryColorIf ?? (() => false);

        return (
            <div style={{
                direction: this.props.ltr ? 'ltr' : 'rtl',
                display: 'inline-flex',
                justifyContent: 'center',
                ...this.props.style,
            }}>
                {
                    steps.map((x, ix) => (
                        <Step key={'step_' + ix} counter={x.counter ?? ix + 1}
                            text={x.text ?? ''}
                            counterBackground={secondaryColorIf(x, ix) ? this.props.secondaryColor : this.props.primaryColor}
                            onClick={x.onClick ?? (arg => this.props.onItemClick?.(x, ix, arg))}
                        />
                    ))
                }
            </div>
        );
    }
}

StepCounter.propTypes = {
    ltr: PropTypes.bool,
    steps: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
    texts: PropTypes.arrayOf(PropTypes.string),
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    secondaryColorIf: PropTypes.func,
    onItemClick: PropTypes.func,
    style: PropTypes.object,
};

export default StepCounter;

/*
example:

    <StepCounter texts={['علی', 'حسن', 'حسین', 'سجاد']}
        primaryColor='green' secondaryColor='darkred'
        secondaryColorIf={(step, ix) => ix > this.state.stepIndex}
        onItemClick={(step, stepIndex) => this.setState({ stepIndex })}
    />

*/